module.exports = __webpack_public_path__ + "img/LASTEST_MV.aed8abff.png";